import React, { useContext, useEffect, useState } from "react";
import constants from "../../../constants";
import { useLocation } from "react-router-dom";
import useLogout from "../../../Hooks/useLogout";
import { getDataFromStorage } from "../../../util";
import MenuSvgIcon from "../../../Svg/MenuSvgIcon";
import ChevronUpSvg from "../../../Svg/ChevronUpSvg";
import AlertContext from "../../../context/AlertContext";
import ChevronDownSvg from "../../../Svg/ChevronDownSvg";
import { Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import SharePublicProfileButton from "../../PublicProfile/SharePublicProfileButton";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";
export default function MenuBarFooter() {
  const Alert = useContext(AlertContext);
  const { getPreSignedUrl } = useS3FileManagement();
  const logOut = useLogout();
  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  let evaluationBatch = [];
  const [showRaiseIssue, setShowRaiseIssue] = useState(true);
  const [profilePic, setProfilePic] = useState(
    localStorage.getItem("picture")
  );
  const getLatestSessions = async (learnerid, from) => {
    let cond = getDataFromStorage("role") === constants.Roles.learner;

    if (cond) {
      let res = await axios.get("node/learner/activesession/" + learnerid, {
        headers: {
          "Content-type": "application/json",
        },
      });

      if (from !== "root") {
        if (!res.data.data.hasOwnProperty("resolveddata")) {
          let jwtToken = res.data.data.jwtToken;
          let sessionName = res.data.data.sessions[0].sessionName;
          let sessionDate = res.data.data.sessions[0].sessionDate;
          let sessionTime = res.data.data.sessions[0].sessionTime;

          let notificationData = {
            open: true,
            data: {
              notification: {
                title: `Attendance:\n${sessionName}`,
                body: `Date: ${sessionDate}\nTime: ${sessionTime}\nPlease mark correctly as the coordinator will be checking it manually as well.`,
              },
              data: {
                jwtToken: jwtToken,
              },
            },
          };

          Alert.setNotificationPayload(notificationData);
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: res.data.data.resolveddata,
          });
        }
      } else {
        return !res.data.data.hasOwnProperty("resolveddata");
      }
    }
  };

  // console.log("Alert.userBatch:", Alert.userBatch);
  // console.log("evaluationBatch:", evaluationBatch);

  useEffect(() => {
    // console.log("useEffect ran..");
    Alert.userBatch?.map((batch) => {
      if (batch.type === constants.BATCH_TYPE.TESTING) {
        evaluationBatch.push(batch);
      }
    });

    if (Alert.userBatch.length === evaluationBatch.length) {
      setShowRaiseIssue(false);
    }
    else {
      setShowRaiseIssue(true);
    }
  }, [Alert.userBatch, evaluationBatch]);

  useEffect(() => {
    const loadProfilePicture = async () => {
      let picture = localStorage.getItem("picture");

      if (!picture) {
        return;
      }

      try {
        const res = await getPreSignedUrl(
          [picture],
          undefined,
          "",
          "GET"
        );

        setProfilePic(res?.url?.[0] || picture);
      } catch (err) {
        console.log(err);

        setProfilePic(picture);
      }
    };

    loadProfilePicture();
  }, []);


  // console.log("showRaiseIsse:",showRaiseIssue);

  return (
    <Menu
      className="menuBarFooterMainContainer"
      renderExpandIcon={({ open }) => (
        <span>
          {open ? <ChevronDownSvg from="menu" /> : <ChevronUpSvg from="menu" />}
        </span>
      )}
    >
      {/* {!useCommonFunctionHks.checkBatchType() &&
        getDataFromStorage("role") !== constants.Roles.parent && (
          <MenuItem
            className="menuBarFooterMenuList"
            active={pathname.includes("doubts")}
            onClick={() => Alert.navigate("main/doubts")}
            prefix={<MenuSvgIcon menuId={constants.MENU_ICON.DOUBTS} />}
          >
            Ask Doubts
          </MenuItem>
        )} */}
      {!useCommonFunctionHks.checkBatchType() &&
        getDataFromStorage("role") !== constants.Roles.parent && (
          <MenuItem
            className="menuBarFooterMenuList"
            active={pathname.includes("noticeboard")}
            onClick={() => Alert.navigate("main/noticeboard")}
            prefix={<MenuSvgIcon menuId={constants.MENU_ICON.NOTICEBOARD} />}
          >
            Notice Board
          </MenuItem>
        )}
      <MenuItem className="menuBarFooterMenuList menuFooterShareProfile">
        <SharePublicProfileButton />
      </MenuItem>

      {Alert.showBlink && (
        <MenuItem
          className="menuBarFooterMenuList"
          onClick={() => getLatestSessions(getDataFromStorage("learnerid"))}
          prefix={<MenuSvgIcon menuId={constants.MENU_ICON.NOTIFICATION} />}
        >
          Attendance
        </MenuItem>
      )}
      <SubMenu
        className="menuBarFooterSubMenu"
        label={getDataFromStorage("name")}
        open={isOpen}
        icon={
          <img
            className="menuBarFooterProfileImg"
            src={profilePic}
            alt={getDataFromStorage("name").substring(0, 1).toUpperCase()}
          />
        }
        onClick={() => setIsOpen(!isOpen)}
      >
        {!useCommonFunctionHks.checkBatchType() &&
          showRaiseIssue &&
          getDataFromStorage("role") !== constants.Roles.parent && (
            <MenuItem
              className="menuBarFooterMenuList"
              active={pathname.includes("issue")}
              onClick={() => {
                Alert.navigate("main/issue");
                setIsOpen(false);
              }}
              prefix={<MenuSvgIcon menuId={constants.MENU_ICON.ISSUE} />}
            >
              Raise an Issue
            </MenuItem>
          )}

        {getDataFromStorage("role") !== constants.Roles.hr &&
          getDataFromStorage("role") !== constants.Roles.customer &&
          getDataFromStorage("role") !== constants.Roles.parent &&
          getDataFromStorage("role") !== constants.Roles.tutor &&
          parseInt(localStorage.getItem("batchType")) !==
          constants.BATCH_TYPE.TESTING && (
            <MenuItem
              className="menuBarFooterMenuList"
              onClick={() => Alert.navigate("/profile/personalinfo")}
              prefix={<MenuSvgIcon menuId={constants.MENU_ICON.PROFILE} />}
            >
              View Profile
            </MenuItem>
          )}
        <MenuItem
          onClick={logOut}
          className="menuBarFooterMenuList"
          prefix={<MenuSvgIcon menuId={constants.MENU_ICON.LOGOUT} />}
        >
          Logout
        </MenuItem>
      </SubMenu>
    </Menu>
  );
}
